module.exports = __webpack_public_path__ + "static/morze-ad9112fc5ca6a153a8e1e24444f59985.svg";